import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4fcf300"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "float_button" }

import { onMounted } from 'vue';
import BusinessComponent from '../components/BusinessComponent.vue';
import CommonOpenButton from '../components/CommonOpenButton.vue';
import AppLinkStat from '../stats/AppLinkStat';
import AbilityParamsUtil from '../bridge/AbilityParamsUtil';
import PageParamsUtil from '../../utils/PageParamsUtil';
import DeviceEnvUtil from '@/utils/DeviceEnvUtil';

// document.addEventListener(
//   'touchstart',
//   function (event) {
//     if (event.touches.length > 1) {
//       event.preventDefault();
//     }
//   },
//   {
//     capture: false,
//     passive: false,
//   },
// );

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAbility',
  setup(__props) {

onMounted(() => {
  AppLinkStat.eventAbilityPageShow(
    AbilityParamsUtil.getAbilityName(),
    AbilityParamsUtil.getAbilityBusinessId(),
    PageParamsUtil.getPageUrl(),
  );

  // fix issue： Chrome mobile onResume is not defined
  if (DeviceEnvUtil.isAndroid()) {
    if (typeof window.onResume !== 'function') {
      window.onResume = function () {
        console.log('[H5] onResume called');
      };
    }
  }

  // 外链传入 storeUrl：先展示中间页，再跳转 App Store（返回仍可看到本页）
  const storeUrl = AbilityParamsUtil.getExternalStoreUrl();
  if (storeUrl) {
    setTimeout(() => {
      window.location.href = storeUrl;
    }, 300);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(BusinessComponent)))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createBlock(_KeepAlive, null, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(CommonOpenButton)))
      ], 1024))
    ])
  ]))
}
}

})